var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceAuthorizationFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 96",
    style: {
      enableBackground: "new 0 0 136 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#64496A;}\r\n\t.st1{fill:#F2F2F2;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#C0DAFC;}\r\n\t.st4{fill:#78A0D4;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,2c0,0,115.9,0,122.4,0c8.2-0.2,3.5,18.2,4.7,45.2c-1.4,29,3.8,45.7-4.5,46.9C125,94,13.3,94,6.9,94 c-8.1,0.1-3.6-17.2-4.7-43.4C3.7,22.2-1.6,3.2,6.7,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.8,85.2h96.4c0-4.8,3.9-8.8,8.8-8.8v-57c-4.8,0-8.8-3.9-8.8-8.8H19.8c0,4.8-3.9,8.8-8.8,8.8v57 C15.9,76.5,19.8,80.4,19.8,85.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.4,12.6c-0.1-0.6-0.2-1.2-0.2-1.8H19.8c0,4.8-3.9,8.8-8.8,8.8v57c2.3,0,4.5,0.9,6.1,2.5 C145,75.1,111.9,101.4,116.4,12.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,17.3h39.4v4.4H26.4V17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,26.1h65.7v4.4H26.4V26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,34.9h83.2v4.4H26.4V34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,43.1h83.2v4.4H26.4V43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,51.3h83.2v4.4H26.4V51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,59.5h83.2v4.4H26.4V59.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.5,74.3h13.1v4.4H96.5V74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.4,74.3h13.1v4.4H26.4V74.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceAuthorizationFile);
export default __webpack_public_path__ + "static/media/service-authorization-file.885f819748e994bc3f2b996fe75b3a98.svg";
export { ForwardRef as ReactComponent };